import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=bfe5252a&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfe5252a')) {
      api.createRecord('bfe5252a', component.options)
    } else {
      api.reload('bfe5252a', component.options)
    }
    module.hot.accept("./modal.vue?vue&type=template&id=bfe5252a&", function () {
      api.rerender('bfe5252a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/modal.vue"
export default component.exports